import { render, staticRenderFns } from "./Doctores.vue?vue&type=template&id=5b4a48ba"
import script from "./Doctores.vue?vue&type=script&lang=js"
export * from "./Doctores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports